module.exports = __webpack_public_path__ + "static/media/ic_general_sea_black.90b25915.svg";